<template>
  <div
    v-show="!hidePlaceholder"
    ref="pager"
  >
    <div>
      <div
        v-if="loading"
        class="text-xs-center py-2">
        <v-progress-circular
          indeterminate
          small
          color="primary"
        />
      </div>
      <template
        v-if="!loading && noneData">
        <slot name="noneData"/>
        <div
          v-if="!$slots.noneData"
          class="text-xs-center py-2 grey--text">
          暫無數據
        </div>
      </template>

      <template v-else-if="!hidePage">
        <div
          v-if="pull"
          class="text-xs-center">
          <template
            v-if="noMore"
          >
            <slot name="noMore"/>
            <div
              v-if="!$slots.noMore"
              class="py-4 grey--text"
            >
              我是有底線的
            </div>
          </template>
          <!-- <v-btn
            v-else-if="!loading"
            color="info"
            @click="next">Load More</v-btn> -->
        </div>
        <div
          v-else
          v-show="!noneData && pageCount > 1"
          class="text-xs-center py-2"
        >
          <v-pagination
            v-model="number"
            :length="pageCount"
            :total-visible="totalVisible"
            @input="changeNumber"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pager',
  props: {
    'totalVisible': {
      type: [Number, String],
      default: 15,
    },
    size: {
      type: Number,
      default: 20
    },
    initNumber: {
      type: Number,
      default: 1
    },
    onFetch: {
      type: Function,
      required: true
    },
    autoFetch: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line
    pull: Boolean, // 是否 瀑布式加载
    // eslint-disable-next-line
    hidePage: Boolean // 是否 隱藏分頁按鈕
  },
  data () {
    return {
      number: this.initNumber,
      loading: false,
      noMore: false,
      noneData: false,
      total: 0,
      first: true // 第一次加载数据
    }
  },
  computed: {
    hidePlaceholder () {
      if (this.hidePage) {
        return !this.loading && !this.noneData
      } else {
        return false
      }
    },
    pageCount () {
      if (this.total === 0) {
        return 0
      }
      return parseInt(this.total / this.size) + (this.total % this.size > 0 ? 1 : 0)
    }
  },
  created () {
    window.addEventListener('scroll', this.onScroll)
    if (this.autoFetch) {
      this.fetch()
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  activated () {
    window.addEventListener('scroll', this.onScroll)
  },
  deactivated () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      if (this.pull && this.$refs.pager && this.$refs.pager.getBoundingClientRect().top - document.documentElement.clientHeight < window.innerHeight / 2) {
        if (!this.loading) {
          this.next()
        }
      }
    },
    next () {
      this.number += 1
      this.fetch()
    },
    changeNumber (v) {
      this.number = v
      this.fetch()
    },
    fetch () {
      this.loading = true
      this.onFetch({
        first: this.first,
        size: this.size,
        number: this.number
      }).then(({ size, total }) => {
        this.loading = false
        this.first = false
        if (!this.pull) {
          this.total = total
        }
        // if (size < this.size) {
        if (size < 1) {
          this.noMore = true
          if (this.number === 1) {
            this.noneData = true
          }
        }
        if (this.pull && size < this.size && this.number < 3) {
          this.next()
        }
      }).catch((e) => {
        this.loading = false
        console.error(e)
      })
    },
    reload () {
      this.noneData = false
      this.noMore = false
      this.number = 1
      this.fetch()
    },
    reFetch () {
      this.noMore = false
      this.fetch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pager.vue